const companyData = [
    {
        id: 0,
        name: 'Spotify',
        pictUrl: '/assets/image/spotify.png',
    },
    {
        id: 1,
        name: 'Google',
        pictUrl: '/assets/image/google.png',
    },
    {
        id: 2,
        name: 'Uber',
        pictUrl: '/assets/image/uber.png',
    },
    {
        id: 3,
        name: 'Microsoft',
        pictUrl: '/assets/image/microsoft.png',
    },
    {
        id: 4,
        name: 'Shopify',
        pictUrl: '/assets/image/shopify.png',
    },
    {
        id: 5,
        name: 'Evernote',
        pictUrl: '/assets/image/evernote.png',
    },
    {
        id: 6,
        name: 'Adobe',
        pictUrl: '/assets/image/adobe.png',
    },
    {
        id: 7,
        name: 'Paypal',
        pictUrl: '/assets/image/paypall.png',
    },
    {
        id: 8,
        name: 'Amazon',
        pictUrl: '/assets/image/amazon.png',
    },
    {
        id: 9,
        name: 'Asana',
        pictUrl: '/assets/image/asana.png',
    },
]

const accordionData = [
    {
        title: 'How do i sign up for the project?',
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat.`,
    },
    {
        title: 'What thing that i should prepare before starting?',
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat.`,
    },
    {
        title: 'Does my company need help for infrastructure advices?',
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat.`,
    },
]

const testimonialData = [
    {
        profilePict: '/assets/image/photo.png',
        name: 'Amelia Joseph',
        position: 'Chief Manager',
        description: 'My vision came alive effortlessly. Their blend of casual and professional approach made the process a breeze. Creativity flowed, and the results were beyond my expectations.'
    },
    {
        profilePict: '/assets/image/photo1.png',
        name: 'Jacob Joshua',
        position: 'Chief Manager',
        description: `I found the digital expertise I needed. Their creative-professional balance exceeded expectations. Friendly interactions, exceptional outcomes. For digital enchantment, it's got to be Embrace!`
    },
    {
        profilePict: '/assets/image/photo2.png',
        name: 'Jacob Amalia',
        position: 'Chief Manager',
        description: `Embrace really nails it! Creative brilliance, approachable style. They're the partners you want—artistry meets strategy. Thrilled with what they achieved!"`
    },
]
export { companyData, accordionData, testimonialData }